import {CommonService} from '../../../../services/common.service';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatDialogRef} from '@angular/material/dialog';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {AutomationsService} from '../../../../services/automations.service';

@Component({
  templateUrl: './new-notification.component.html'
})
export class NewNotificationComponent implements OnInit {
  commandTypes: any;
  types: any;
  title: string;
  email: string;
  selectedCommandType: any;
  selectedNotificationType: any;
  selectedUser: any;
  users: any;
  public filteredUsers: any;

  constructor(private commonService: CommonService,
              private matDialogRef: MatDialogRef<NewNotificationComponent>,
              private automationsService: AutomationsService,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = 'Προσθήκη νέας ειδοποίησης';
    this.email = '';
    this.users = [];
  }

  public async ngOnInit(): Promise<any> {
    await this.initializeCommandTypes();
    await this.initializeTypes();
    await this.initializeUsers();
  }

  async initializeCommandTypes() {
    try {
      this.commandTypes = await this.automationsService.fetchCommandTypes();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async initializeTypes() {
    try {
      this.types = await this.automationsService.fetchTypes();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async initializeUsers() {
    try {
      this.users = await this.commonService.getSimpleList(`user?filter=(is_mobile_user=1 AND status_value=1 AND name IS NOT NULL)&order=name asc`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }


  close(part?) {
    this.matDialogRef.close(part);
  }

  formInvalid(): boolean {
    if (this.selectedNotificationType) {
      if (this.selectedNotificationType.id === 1) {
        return !this.selectedCommandType || !this.email;
      } else {
        return !this.selectedCommandType || !this.selectedUser;
      }
    } else {
      return true;
    }
  }

  submitForm() {
    let model;
    if (this.selectedNotificationType.id === 1) { // email
      model = {
        email: this.email,
        type_id: this.selectedCommandType.id,
        type: this.selectedNotificationType.id
      };
    } else { // push notification
      model = {
        user_id: this.selectedUser.id,
        type_id: this.selectedCommandType.id,
        type: this.selectedNotificationType.id
      };
    }
    this.close(model);
  }
}
